import { ApolloClient } from '@apollo/client';
import { ApolloLink } from '@apollo/client';
import { HttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { InMemoryCache } from '@apollo/client/cache';
import Okta from 'providers/Okta';

import sentryBreadcrumbLink from 'apollo/config/sentryBreadcrumbLink';

const getToken = () => {
  const auth = Okta('start');

  return auth.client.tokenManager.get('startplusAccess').then(token => {
    if (token) return token.accessToken;

    return auth.client.token
      .getWithoutPrompt({
        responseType: 'token',
        scopes: ['openid'],
      })
      .then(({ tokens: { accessToken } }) => {
        auth.client.tokenManager.add('startplusAccess', accessToken);
        return accessToken.value;
      });
  });
};

// cached storage for the user token
let token;
const withToken = setContext((_request, { headers, ...prevContext }) => {
  // if you have a cached value, return it immediately
  if (token)
    return {
      ...prevContext,
      headers: { ...headers, authorization: `Bearer ${token}` },
    };

  return getToken().then(newToken => {
    token = newToken;
    return {
      ...prevContext,
      headers: { ...headers, authorization: `Bearer ${token}` },
    };
  });
});

const resetToken = onError(({ networkError }) => {
  if (
    networkError &&
    networkError.name === 'ServerError' &&
    networkError.statusCode === 401
  ) {
    // remove cached token on 401 from the server
    token = null;
  }
});

const authFlowLink = withToken.concat(resetToken);

const getClient = async () => {
  const uri =
    process.env.REACT_APP_ENVIRONMENT === 'prod'
      ? 'https://prod2-startplus-be.castandcrew.com/graphql'
      : 'https://startplus-qa2.us-west-2.dev.aws.castandcrew.com/graphql';
  const link = new HttpLink({ uri });
  const client = new ApolloClient({
    link: ApolloLink.from([sentryBreadcrumbLink('Start+'), authFlowLink, link]),
    cache: new InMemoryCache(),
  });

  return client;
};

export default getClient;
